module.exports = "<svg viewBox=\"0 0 54 80\"><path d=\"M54 0H0v80h54V0z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/line-small.svg
// module id = 297
// module chunks = 1